import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipesModule } from '../../shared/translate-pipes.module';
import { DropdownSortComponent } from './dropdown-sort.component';

@NgModule({
  imports: [
    CommonModule,
    TranslatePipesModule,
  ],
  exports: [
    DropdownSortComponent,
  ],
  declarations: [DropdownSortComponent],
})
export class DropdownSortModule {
}
